/*
 * GrowthBook Feature Flags
 * Configuration for each flag can be found at: https://flagging.marty.zappos.com/features/<feature-name>
 */

export const FEATURE_SITE_REDESIGN = 'marty.site-redesign';
export const FEATURE_PTCT = 'ptct';
export const FEATURE_MAFIA_AKAMAI = 'marty.mafia.akamai'; // [M]afia behind [Aka]mai
